// Session activation is server-wide for this user's org chat. Serialize surface
// handoffs as well as route changes so an older activation finishes first.
let pending: Promise<unknown> = Promise.resolve()

export function queueAssistantChatOperation<T>(operation: () => Promise<T>): Promise<T> {
  const result = pending.then(operation)
  pending = result.catch(() => {})
  return result
}
